import axios from 'axios'
import { getCookie } from '../../common/util/cookie'


export const Api = {
    baseUrl: process.env.REACT_APP_API_URL,
    baseUrl2: process.env.REACT_APP_API2_URL,

    getUserInfo:function(){
        let _url = this.baseUrl+'/front/v2/user/info'
        const auth_token = getCookie('auth_token')
        let config = {
            // headers: {'X-CSRF-TOKEN': getCookie('XSRF-TOKEN')},
            withCredentials: true,
            xsrfHeaderName: 'Authorization'
        }
        return axios.post(_url, {auth_token}, config)
    },

    getCategorys:function(shopNO){
        let _url = this.baseUrl+"/front/v2/item/cate/";
        if (shopNO) _url += '?idx_b_manager='+shopNO
        return axios.get(_url);
    },

    getCategoryV3:function({ minishopIdx }){
        let _url = `${this.baseUrl}/front/v3/item/cate?idx_b_manager=${minishopIdx}`
        return axios.get(_url)
    },

    getMallInfo:function(mall_name, b_manager){
        let _url = this.baseUrl+'/common/information/manager/'
        if (b_manager !== undefined) {
            _url += b_manager;
        } else {
            _url += '?mall_web_user='+mall_name;
        }
        return axios.get(_url);
    },

    getAnniversary:function(){
        let _url = this.baseUrl+"/front/v2/common/anniversary/"
        return axios.get(_url);
    },

    getCategoryMedium:function(cate_id){
        let _url = this.baseUrl+"/front/v2/medium/headList/"+cate_id;
        return axios.get(_url);
    },

    getMainBanner:function(){
        let _url = this.baseUrl+"/front/v2/banner/header";
        return axios.get(_url);
    },

    getLatestItem:function(data){
        let _url = this.baseUrl+"/front/v3/item/latest";
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        return axios.post(_url, data, config)
    },

    getCurations: function() {
        let _url = this.baseUrl + '/front/v3/item/main/curation'
        return axios.get(_url)
    },

    getSearchRank:function() {
        let _url = `${this.baseUrl}/front/v3/search/ranking`
        return axios.get(_url);
    },

    getAutoComplete:function(word) {
        let _url = `${this.baseUrl}/front/v3/search/autoComplete?query=${word}`
        return axios.get(_url);
    },
    // 조립PC 가능한 미니샵 리스트
    getMinishopList:function() {
        let _url = `${this.baseUrl}/front/v3/stdpc/search/minishoplist`
        return axios.get(_url);
    },
    getMinishopLogo:function(idx_b_manager,type) {
        let _url = `${this.baseUrl2}/desktop/v1/logo/${idx_b_manager}/`
        if (type !== undefined) {
            _url += type
        }
        return axios.get(_url);
    },

    /**
     * 미니샵 찜하기
     * @param idx_member
     * @param idx_b_manager
     * @param zzim_state 1: 찜 등록, 2: 찜 삭제
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateMinishopZzim: function(idx_member, idx_b_manager, zzim_state) {
        let _url = `${this.baseUrl}/common/information/manager/minishopzzim/${idx_b_manager}/${idx_member}?zzim_state=${zzim_state}`
        return axios.get(_url)
    }
}



// WEBPACK FOOTER //
// ./src/header/libs/api.js